import { Box, Grid, Typography } from '@mui/material';
import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import CustomisedButton from '../../components/button/button';
import CustomisedTextField from '../../components/textField/textField';
import { ISendOtpRequest, ISendOtpResponse } from '../../models/account.model';
import { sendOtp } from '../../services/account.service';

import { useDispatch } from 'react-redux';
import GoftinoChat from '../../components/goftino/GoftinoChat';
import InformationAndGuideLinkSection from '../../components/kamanLend/informationAndGuideLinkSection';
import PrivacyLink from '../../components/privacy/privacy';
import {
    EXTERNAL_PROVIDE,
    MAX_WIDTH_OBJ,
    MOBILE,
    NATIONAL_CODE,
    OTP_lENGTH,
    REF_OTP,
    TIME_OTP,
    UUID,
} from '../../config/cacheKey';
import { setUnAuthorizedState } from '../../redux/unAuthorizedState/unAuthorizedStateSlice';
import { IRouteWithState } from '../../routeWithState/IRouteWithState';

const Login = ({ setState }: IRouteWithState) => {
    const [mobile, setMobile] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [selectedCount, setSelectedPart] = useState();
    const [jsonFile, setJsonFile] = useState<any>();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const [disable, setDisable] = useState(true);
    // navigate('/user', { state: { userId } });
    useEffect(() => {
        setDisable(true);
        if (mobile.length === 11 && nationalCode.length === 10) {
            setDisable(false);
        }
    }, [mobile, nationalCode]);
    const yupMobileMax = 11;
    const yupNationalCodeMax = 10;
    const getNumber = (e: any) => {
        setMobile(e.target.value);
    };
    const getNationalCode = (e: any) => {
        setNationalCode(e.target.value);
    };
    const mobileNumberCodeHandleKeyDown = (event: any) => {
        var key = event.keyCode ? event.keyCode : event.which;
        if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
            event.preventDefault();
        }
        if (
            event.target.value.length >= yupMobileMax &&
            key != 8 &&
            key != 46 &&
            selectedCount === 0
        ) {
            event.preventDefault();
        }
    };
    const nationalCodeHandleKeyDown = (event: any) => {
        var key = event.keyCode ? event.keyCode : event.which;
        if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
            event.preventDefault();
        }
        if (
            event.target.value.length >= yupNationalCodeMax &&
            key != 8 &&
            key != 46 &&
            selectedCount === 0
        ) {
            event.preventDefault();
        }
    };
    const currentSelection = (e: any) => {
        setSelectedPart(
            e.target.value.substring(
                e.target.selectionStart,
                e.target.selectionEnd
            ).length
        );
    };

    useEffect(() => {

        fetch('/setting/shellConfig.json')
            .then((response) => response.json())
            .then((data) => {
                setJsonFile(data);
            });
        // clearLocalStorage(['goftino', 'goftino_qzVes1'])
        localStorage.clear()

    }, []);

    const [formInfo, setFormInfo] = useState({
        nationalCode: '0068556666',
        brithDate: '1958-02-05',
    });
    function handleDateChange(event: any, key: string, value: Date) {
        setFormInfo({ ...formInfo, [key]: value as Date });
    }
    const dispatch = useDispatch();
    const { mutateAsync: sendOptMutation, isLoading } = useMutation(sendOtp, {
        onSuccess: (data: ISendOtpResponse) => {
            if (data) {
                queryClient.setQueryData(REF_OTP, data.key);
                queryClient.setQueryData(TIME_OTP, data.otpLifetime);
                queryClient.setQueryData(OTP_lENGTH, data.otpLength);
                dispatch(setUnAuthorizedState({ state: `otp ${UUID}` }))
                // navigate('/otp');
            }
        },
    });


    return (

        <>
            <Box
                maxWidth={MAX_WIDTH_OBJ}
                style={{
                    textAlign: 'center',
                    display: 'block',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: 'auto',
                    position: 'relative',
                    top: '50%',
                    transform: 'translateY(-50%)',
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>

                    <img
                        src={jsonFile?.loginLogo}
                        alt="logo"
                        style={{ width: "80px", height: "80px" }}
                    />
                </Box>

                <div className="px-5">
                    <Typography
                        className="text-center !mb-5"
                        paddingTop={'10px'}
                    >
                        {/* <CustomisedTitleFont14 title={' ورود به  کمان لند'} /> */}
                    </Typography>
                    <Typography
                        className=" text-center primaryColorLight-900"
                        style={{ fontSize: '1rem' }}
                    >
                        برای ورود، شمـاره موبایل و کدمـلی خود را وارد نمایید.
                    </Typography>
                    <Formik
                        initialValues={{} as ISendOtpRequest}
                        validateOnMount={true}
                        onSubmit={(values) => {
                            queryClient.setQueryData(MOBILE, mobile);
                            sessionStorage.removeItem(EXTERNAL_PROVIDE)
                            queryClient.setQueryData(
                                NATIONAL_CODE,
                                nationalCode
                            );
                            sendOptMutation({
                                mobileNumber: mobile,
                                nationalCode: nationalCode,
                            });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            touched,
                            handleBlur,
                        }) => (
                            <form
                                onSubmit={handleSubmit}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleSubmit();
                                    }
                                }}
                            >
                                <div className="mt-10 text-center">
                                    <Grid
                                        container
                                        className="row"
                                        spacing={2}
                                        style={{
                                            alignItems: 'center',
                                            width: '98%',
                                            margin: 'auto',
                                        }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            style={{ padding: '0px' }}
                                            className="yekanBakhFaNum"
                                        >
                                            <CustomisedTextField
                                                maxWidth={MAX_WIDTH_OBJ}
                                                helperText={
                                                    !touched.mobileNumber
                                                        ? errors.mobileNumber
                                                        : ''
                                                }
                                                error={
                                                    !touched.mobileNumber &&
                                                    Boolean(errors.mobileNumber)
                                                }
                                                label="شماره موبایل"
                                                placeholder={'09128765432'}
                                                required={true}
                                                inputProps={{ type: 'tel', maxLength: 11, pattern: "[0-9]*", inputMode: 'numeric', lang: 'en' }}
                                                value={mobile}
                                                onChange={getNumber}
                                                name="mobileNumber"
                                                id="mobileNumber"
                                                // onKeyDown={
                                                //     mobileNumberCodeHandleKeyDown
                                                // }
                                                // onSelect={currentSelection}
                                                onBlur={handleBlur}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            style={{
                                                padding: '0px',
                                                paddingTop: '30px',
                                            }}
                                        >
                                            <CustomisedTextField
                                                maxWidth={MAX_WIDTH_OBJ}
                                                helperText={
                                                    !touched.nationalCode
                                                        ? errors.nationalCode
                                                        : ''
                                                }
                                                error={
                                                    !touched.nationalCode &&
                                                    Boolean(errors.nationalCode)
                                                }
                                                label="کد ملی"
                                                placeholder={'0012345678'}
                                                required={true}
                                                inputProps={{ type: 'tel', maxLength: 10, inputMode: 'numeric', lang: 'en' }}
                                                value={nationalCode}
                                                onChange={getNationalCode}
                                                name="nationalCode"
                                                id="nationalCode"
                                                // onKeyDown={
                                                //     nationalCodeHandleKeyDown
                                                // }
                                                onSelect={currentSelection}
                                                onBlur={handleBlur}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                                <div style={{ paddingTop: '30px' }}>
                                    <Grid
                                        container
                                        className="row"
                                        spacing={2}
                                        style={{
                                            alignItems: 'center',
                                            width: '98%',
                                            margin: 'auto',
                                            maxWidth: MAX_WIDTH_OBJ,
                                        }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            style={{ padding: '0px' }}
                                        >
                                            <CustomisedButton
                                                title={'ادامه'}
                                                disable={disable}
                                                onClick={() => { }
                                                }
                                                type="submit"
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                                <PrivacyLink onClick={() => dispatch(setUnAuthorizedState({ state: `privacyStatementsLogin ${UUID}` }))} />
                                {/* newFlow****** */}
                                {/* <p style={{ fontSize: '10px' }} onClick={() => {
                                    dispatch(setUnAuthorizedState({ state: `UnauthorizedContainer ${UUID}` }))

                                }}>بازگشت </p> */}
                            </form>
                        )}
                    </Formik>
                </div>
                <Box sx={{
                    paddingInline: "20px", marginTop: "15px",
                    marginInline: "1px",
                }}>

                    <InformationAndGuideLinkSection height={'100px'} />
                </Box>
            </Box>
            <GoftinoChat />
        </>



    );
};

export default Login;
